import { Button } from '@octopus-do/octopus-storybook'
import { Sparkles } from '@octopus-do/octopus-storybook/icons'
import { migrationArtBoardSelectors } from '@store/migrationSelectors/artBoardSelectors'
import { AIActions } from '@store/reducers/ai'
import { artBoardActions } from '@store/reducers/artboard'
import { useDispatch, useSelector } from 'react-redux'

export const AIChatButton = () => {
  const dispatch = useDispatch()
  const showAiChat = useSelector(migrationArtBoardSelectors.getIsShowAiChat)

  const handleClick = async () => {
    if (showAiChat) {
      dispatch(
        artBoardActions.showAiChat({
          showAiChat: false,
        })
      )
    } else {
      dispatch(AIActions.startChat({}))
    }
  }

  return (
    <Button
      tone="ai"
      size="medium"
      left={Sparkles}
      aria-label="AI assistant"
      active={showAiChat}
      onClick={handleClick}
    />
  )
}
